export default __webpack_public_path__ + "static/media/slider-5.679a48a6.jpg";